import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconLeaf = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconLeaf",
  viewBox: "0 0 20 20",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M18.3 1.9a.4.4 0 0 0-.35-.23c-14.7 0-16.28 6.09-16.28 8.7q0 1.43.62 2.63.1.19.33.2a.4.4 0 0 0 .33-.2c1-1.7 3.8-5.94 8.45-8.19a.4.4 0 0 1 .5.18.4.4 0 0 1-.17.5q-.52.26-1.02.55l-.37.23a16 16 0 0 0-1.07.72l-.16.12c-4.62 3.44-7.44 8.93-7.44 10.84a.38.38 0 0 0 .75 0c0-.6.42-1.84 1.2-3.32a7 7 0 0 0 4.49 1.43c4.86 0 5.88-4.63 6.43-7.11.73-3.35 2.35-5.3 3.68-6.64.11-.1.14-.27.08-.4"
  })
}));
IconLeaf.displayName = 'IconLeaf';